import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ImageStylePage = loadAsyncComponent(
  () => import(/* webpackChunkName: "ImageStylePage" */ './Container'),
  'page'
);
